import React, { Component } from "react";
import axios from "axios";
import { Button, Col, Form, Input, message, Modal, Row, Spin } from "antd";
import QueueAnim from "rc-queue-anim";

import { API_ERRO_TYPE_CANCEL } from "./../../config/general";

import { settingService } from "./../../redux/services";

class Index extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			isSending: false,
		};

		this._cancelToken = null;
	}

	componentDidMount() {
		this._cancelToken = axios.CancelToken.source();

		settingService.getGeneral(this._cancelToken.token)
		.then((response) => {
			this.setState({
				isLoading: false,
			});

			// Fill form
			this.fillForm(response.data.data);
		})
		.catch((data) => {
			if( data?.error_type === API_ERRO_TYPE_CANCEL ) return null;

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	}

	componentWillUnmount() {
		this._cancelToken && this._cancelToken.cancel("Landing Component got unmounted");
	}

	fillForm = (data) => {
		this.form && this.form.setFieldsValue({
			app_url_android: data.app_url_android,
			app_url_ios    : data.app_url_ios,
			email_support  : data.email_support,
		});
	};

	onFinish = (values) => {
		this.setState({
			isSending: true,
		});

		settingService.updateGeneral(values)
		.then((response) => {
			this.setState({
				isSending: false,
			});

			// Success message
			message.success("Configuração atualizada.");
		})
		.catch((data) => {
			this.setState({
				isSending: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	render() {
		const {isLoading, isSending} = this.state;

		return (
			<QueueAnim className="site-content-inner page-settings">
				<div className="page-content" key="1">
					<h1 className="page-title">Configurações gerais</h1>
					<Form
						ref={el => this.form = el}
						layout="vertical"
						scrollToFirstError
						onFinish={this.onFinish}>
						{isLoading ? (
							<div className="text-center" style={{padding: 20}}>
								<Spin indicator={<i className="fad fa-spinner-third fa-spin fa-3x" />} />
							</div>
						) : (
							<Row gutter={24}>
								<Col xs={24} sm={14}>
									<Form.Item name="app_url_android" label="Link do app na Google Play" hasFeedback rules={[{type: "url", message: "Informe um e-mail válido."}]}>
										<Input />
									</Form.Item>
									<Form.Item name="app_url_ios" label="Link do app na Apple Store" hasFeedback rules={[{type: "url", message: "Informe um e-mail válido."}]}>
										<Input />
									</Form.Item>
									<Form.Item name="email_support" label="E-mail de suporte" hasFeedback rules={[{type: "email", message: "Informe um e-mail válido."}]}>
										<Input />
									</Form.Item>
									<Button type="primary" htmlType="submit" icon={<i className="far fa-check" />} loading={isSending} disabled={isLoading}>{isSending ? "Salvando" : "Salvar"}</Button>
								</Col>
							</Row>
						)}
					</Form>
				</div>
			</QueueAnim>
		)
	}
}

export default Index;
